export default `
特定商取引法に基づく表記

運営会社名称
株式会社ゼロプレイス


代表責任者
成田 優樹


会社登記住所・営業所住所
〒330-0854
埼玉県さいたま市大宮区桜木町1丁目195‑1  
大宮ソラミチKOZ4階



電話番号
050-1724-5360
( ※受付時間 : 平日10時-17時 )


メールアドレス
support@xeroplace.jp
※お問い合わせは、サイト内のチャットよりお願いいたします。原則2営業日以内にはお返事いたします。


価格
各商品毎に表示


商品代金以外の必要料金
当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料


引渡時期
申込受付時


販売数量
特に指定はございません。


お支払い方法
クレジットカード・コンビニエンスストア・PayPal・キャリア決済・PayPay・メルペイ・AmazonPayとなります。
※ご決済後のお客様都合によるキャンセルは承ることができません。予めご容赦ください。
期限までにお支払いがない場合、自動的にキャンセルとなります。


支払時期
クレジットカード：クレジットカード会社の規約に基づく。
コンビニ決済：ご注文日から３日以内に代金をお支払いください。
PayPal：PayPalの規約に基づく。
キャリア決済：各キャリアの規約に基づく。
PayPay：PayPayの規約に基づく。
メルペイ：メルペイの規約に基づく。
Amazonpay：Amazonpayの規約に基づく。


返品特約と期限
サービスの性質上、返品・返金はお受けしておりません。
ただし、弊社に100％過失がある場合はご対応させてただきます。
以下の場合はご対応いたしかねます。予めご容赦くださいませ。
配送過程での紛失や損傷等が生じてしまった場合
BOX等未開封品の動画撮影等が無い場合
※再シュリンク品の検品は特に留意しておこなわせていただいております。
商品ご到着後、10日を超えた場合
PSAなどの鑑定品に傷等が見受けられてしまい、それを理由とした交換・返品依頼を承った場合


古物商営業許可
第431370066203
株式会社ゼロプレイス
埼玉県公安委員会


`;
